import { render, staticRenderFns } from "./vehicleSetting.vue?vue&type=template&id=44565a25"
import script from "./vehicleSetting.vue?vue&type=script&lang=js"
export * from "./vehicleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports